import axiosInstance from "../config/axios.config";

export const getUsageEventsApi = (params) =>
  axiosInstance.get("/accounts/admin-dashboard/usage-events/", {
    params: {
      limit: 100,
      ...params,
    },
    paramsSerializer: (p) => {
      const searchParams = new URLSearchParams();
      Object.entries(p).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v));
        } else {
          searchParams.append(key, value);
        }
      });
      return searchParams.toString();
    },
  });
export const getUsageSummaryApi = (params) =>
  axiosInstance.get("/accounts/admin-dashboard/usage-summary/", {
    params: {
      ...params,
    },
  });
